export const tempate_1 = `
    <ul>
      <li>Facebook: <a href="https://facebook.com/NEUReader">facebook.com/NEUReader</a></li>
      <li>Email: <a href="mailto:cait.neureader@gmail.com">cait.neureader@gmail.com</a></li>
    </ul>
    <p>
      Hy vọng rằng, bạn sẽ tiếp tục có những đóng góp/báo lỗi lên hệ thống để
      chúng tôi tiếp tục hoàn thiện và phát triển NEU Reader, trở thành ứng dụng
      đọc sách và tài liệu đáng tin cậy của sinh viên trường Đại học Kinh tế
      Quốc dân.
    </p>
    <p>Trân trọng,</p>
    <p>Đội ngũ phát triển NEU Reader</p>
`
